import { createAction, props } from '@ngrx/store';
import { IClassifyData, IClassifyModel } from '@partners/api';

export class ClassifyActions {
  static submit = createAction('[classify] Submit');
  static submitSuccess = createAction('[classify] Submit Success', props<{  model: IClassifyModel; data: IClassifyData }>());
  static submitFailure = createAction('[classify] Submit Failure', props<{ error: any }>());
}
